import { render, staticRenderFns } from "./GeolocateCard.vue?vue&type=template&id=5072e79c&"
import script from "./GeolocateCard.vue?vue&type=script&lang=js&"
export * from "./GeolocateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports